<template>
    <BaseModalNew :title="''" @close="closeModal">
        <template #modalContent>
            <div class="m-content-wrapper">
                <div class="m-subheading-wrapper">
                    <h3 class="m-content-subheading">
                        Choose an identity
                    </h3>
                    <p v-if="identities.length > 0">Following verified identities found linked with your did account,
                        select one to join</p>
                </div>
                <div class="m-content-div">
                    <ul v-if="identities.length > 0">
                        <li v-for="(identity, index) in identities" :key="index"
                            :class="{ active: identity.isSelected }" @click="selectIdentity(index)">
                            {{ identity.email }}
                        </li>
                    </ul>
                    <p v-else class="text-white text-base">No identities found linked with your account, please verify
                        and add a new identity</p>
                </div>
                <div class="btn-action-wrapper">
                    <button class="mr-2" @click="verifyNewIdentity">Verify new Identity</button>
                    <button @click="confirmIdentity">Confirm Identity</button>
                </div>
            </div>
        </template>
    </BaseModalNew>
</template>

<script>
import BaseModalNew from "@/components/common/BaseModalNew.vue";

export default {
    name: 'SelectIdentitiesModal',
    props: ['closeModal', 'identities', 'meeting_id'],
    components: {
        BaseModalNew,
    },
    methods: {
        selectIdentity(index) {
            console.log(index)
            this.$emit('selectIdentity', index);
        },
        verifyNewIdentity() {
            window.open(`${this.$globals.clientDomain}/profile`, "_blank")
        },
        confirmIdentity() {
            //verify identity here
            const selectedIdentity = this.identities.find(identity => identity.isSelected);
            if (!selectedIdentity) {
                console.log('Identity not selected');
                return;
            }
            const email = selectedIdentity ? selectedIdentity.email : '';
            const payload = {
                cast_id: this.meeting_id,
                email: email
            }
            this.$store.dispatch('cast/isEmailInvited', payload)
                .then((response) => {
                    console.log("responseData", response.data);
                    this.$emit('setIdentityVerified');
                    this.closeModal();
                })
                .catch((error) => {
                    if (error.response && error.response.status === 404) {
                        this.$vs.notify({
                            title: 'Unauthorised identity',
                            text: 'This identity is not invited to join this cast',
                            color: 'danger',
                        });
                    } else {
                        console.log('Login error:', error);
                    }
                });
        }
    },
}
</script>

<style scoped>
*:not(i) {
    /* font-family: 'Karla', sans-serif !important; */
    font-family: 'Rethink Sans' !important;
}

.m-content-wrapper {
    /* background-color: #1B1D29; */
    border-radius: 20px;
    width: 550px;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: 90vh;
    /* overflow-y: scroll; */
}

.m-content-heading {
    display: flex;
    padding: 20px;
    color: #FFFFFF;
}

.m-content-heading span {
    font-size: 14px;
    margin-right: 16px;
    display: flex;
    align-items: center;
}

.m-content-heading h2 {
    font-size: 22px;
    font-weight: 500;
    color: #FFF;
    margin: 0px 0px 0px 10px;
    padding: 0;
}

.m-subheading-wrapper {
    width: 100%;
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.m-subheading-wrapper p {
    color: rgba(255, 255, 255, 0.5);
    font-size: 16px;
    text-align: left;
}

.m-content-subheading {
    font-size: 26px;
    font-weight: 600;
    color: #FFF;
    padding: 0;
    margin: 0;
}

.m-content-subheading span {
    color: #FFFFFF80;
}

.m-content {
    padding: 20px;
    width: 100%;
}

.m-content h2 {
    font-size: 22px;
    font-weight: 500;
    color: #FFF;
    padding: 0;
    margin: 0;
}

.m-subject {
    display: flex;
    margin-top: 12px;
    justify-content: space-between;
}

.m-subject .m-subject-label {
    display: flex;
    align-items: center;
    flex: 2;
}

.m-subject span {
    display: flex;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF80;
}

.m-buttons {
    width: 100%;
    padding: 20px;
}

.m-hr {
    width: 100%;
    border: 1px solid #FFFFFF10;
}

.m-content-div {
    width: 100%;
    padding: 0px 20px 20px 20px;
    display: flex;
}

.cv-btn {
    height: 78px;
    width: 80px;
    background-color: #15161F !important;
    border: 1px solid #242632 !important;
    border-radius: 4px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #FFFFFF;
    font-size: 10px;
    padding: 12px 20px;
    pointer-events: auto;
    margin-right: 10px;
}

.cv-btn svg {
    height: 30px !important;
    width: 30px !important;
    margin-bottom: 10px;
}

li {
    padding: 12px;
    border: 1px solid #FFFFFF30;
    border-radius: 9px;
    margin-bottom: 10px;
    color: #FFFFFF;
    cursor: pointer;
}

li.active {
    border: 1px solid #D3CA57;
}

.btn-action-wrapper {
    display: flex;
    width: 100%;
}

button {
    flex: 1;
    background-color: #D3CA57;
    border: none;
    padding: 10px 20px;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s ease;
}

button:hover {
    background-color: #ebe369;
}
</style>